"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AlertContainerWithoutStore = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./AlertsContainer.scss");
var _RemindersContainer = _interopRequireDefault(require("../reminders/RemindersContainer"));
var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));
var _PulseNotificationMessageWrapper = _interopRequireDefault(require("../message/PulseNotificationMessageWrapper"));
var _Card = _interopRequireDefault(require("../card/Card"));
var _reactTransitionGroup = require("react-transition-group");
var _intl = require("@quarry/intl");
var localizationStrings = _interopRequireWildcard(require("./__localization__/AlertsContainer"));
var _Provider = _interopRequireDefault(require("@react/react-spectrum/Provider"));
var _reactRedux = require("react-redux");
var _NotificationReducer = require("../../store/reducers/NotificationReducer");
var _RemindersReducer = require("../../store/reducers/RemindersReducer");
var _metrics = _interopRequireDefault(require("../../custom-hooks/metrics"));
var _withRedux = _interopRequireDefault(require("../commons/withRedux"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const mapStateToProps = state => ({
  alerts: (0, _NotificationReducer.getNotificationAlerts)(state).map(entry => (0, _NotificationReducer.getNotificationById)(state, entry)),
  reminders: (0, _RemindersReducer.getActiveReminders)(state),
  serverTimeStamp: (0, _NotificationReducer.getServerTimestamp)(state),
  clientTimeStamp: (0, _NotificationReducer.getClientTimestamp)(state),
  locale: (0, _NotificationReducer.getLocale)(state),
  displayAlertsConfig: (0, _NotificationReducer.getDisplayAlertsConfig)(state)
});
const mapDispatchToProps = dispatch => ({
  dispatchToMarkNotificationsAsShown: ids => {
    dispatch({
      type: types.MARK_NOTIFICATIONS_AS_SHOWN,
      ids
    });
  },
  dispatchToMarkAllRemindersAsShown: () => {
    dispatch({
      type: types.MARK_ALL_REMINDERS_AS_SHOWN
    });
  },
  dispatchToMarkReminderAsShown: async id => {
    await dispatch({
      type: types.MARK_REMINDER_AS_SHOWN,
      ids: [id]
    });
  }
});
const AlertsContainer = props => {
  const {
    theme = 'lightest',
    alerts,
    reminders,
    serverTimeStamp,
    clientTimeStamp,
    locale,
    displayAlertsConfig,
    dispatchToMarkNotificationsAsShown,
    dispatchToMarkAllRemindersAsShown,
    dispatchToMarkReminderAsShown
  } = props;
  const metrics = (0, _metrics.default)('exc.pulse.components.alerts.AlertsContainer');
  (0, _react.useEffect)(() => {
    if (alerts.length > 0) {
      if (!displayAlertsConfig.manualDismiss) {
        const floatingAlerTimeoutInMilliseconds = displayAlertsConfig.duration * 1000;
        setTimeout(() => {
          dispatchToMarkNotificationsAsShown(alerts.map(entry => entry.id));
        }, floatingAlerTimeoutInMilliseconds);
      }
    }
  }, [alerts]);
  const onAllRemindersClosed = () => {
    metrics.event('all.reminders.close', {
      region: window.config && window.config.region
    });
    dispatchToMarkAllRemindersAsShown();
  };
  const onReminderClosed = async id => {
    metrics.event('reminder.close', {
      region: window.config && window.config.region
    });
    await dispatchToMarkReminderAsShown(id);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pulse-alerts-container"
  }, /*#__PURE__*/_react.default.createElement(_Provider.default, {
    className: "pulse-provider",
    theme: theme
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alerts-wrapper"
  }, reminders.length > 0 && /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "alert",
    timeout: 500
  }, /*#__PURE__*/_react.default.createElement(_intl.IntlProvider, {
    locale: locale,
    messages: localizationStrings
  }, /*#__PURE__*/_react.default.createElement(_RemindersContainer.default, {
    clientTimeStamp: clientTimeStamp,
    closeHandler: onAllRemindersClosed,
    onReminderClosed: onReminderClosed,
    reminders: reminders,
    serverTimeStamp: serverTimeStamp
  }))), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, alerts.map((entry, key) => /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    classNames: "pulse-alert",
    key: key,
    timeout: 500
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_Card.default, null, /*#__PURE__*/_react.default.createElement(_PulseNotificationMessageWrapper.default, {
    clientTimeStamp: clientTimeStamp,
    isFloatingAlert: true,
    isReminder: false,
    locale: locale,
    pulseMessageObject: entry,
    renderCrossButton: false,
    serverTimeStamp: serverTimeStamp
  })))))))));
};
AlertsContainer.defaultProps = {
  locale: 'en-US',
  localizationStrings: {
    DismissReminder: 'Dismiss reminder',
    DismissAlert: 'Dismiss',
    Snooze: 'Remind me',
    DeleteReminder: 'Delete reminder',
    EditReminder: 'Edit reminder',
    RemindMeTomorrow: 'Remind me tomorrow',
    RemindMe60Min: 'Remind me in an hour',
    RemindMe15Min: 'Remind me in 15 minutes',
    RemindMe5Min: 'Remind me in 5 minutes',
    DismissAllReminders: 'Dismiss all reminders',
    Reminder: 'Reminder',
    Reminders: 'Reminders'
  }
};
const AlertContainerWithoutStore = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AlertsContainer);
exports.AlertContainerWithoutStore = AlertContainerWithoutStore;
var _default = (0, _withRedux.default)(AlertContainerWithoutStore);
exports.default = _default;